var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M7 .35A6.656 6.656 0 0 0 .35 7 6.656 6.656 0 0 0 7 13.65 6.656 6.656 0 0 0 13.65 7 6.656 6.656 0 0 0 7 .35m0 11.802A5.156 5.156 0 0 1 1.848 7 5.156 5.156 0 0 1 7 1.848 5.156 5.156 0 0 1 12.152 7 5.156 5.156 0 0 1 7 12.152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M9.439 4.562a.753.753 0 0 0-1.066 0L7 5.934 5.626 4.562a.753.753 0 0 0-1.065 1.064l1.374 1.372L4.56 8.37a.75.75 0 0 0 0 1.065c.14.14.336.224.533.224.196 0 .378-.07.532-.224L7 8.062l1.374 1.373c.14.14.336.224.532.224s.379-.07.533-.224a.75.75 0 0 0 0-1.065L8.066 6.998l1.373-1.372a.75.75 0 0 0 0-1.064"
  })));
};
export default SvgCancel;